import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

export function NotFound() {
  const { t } = useTranslation('common');
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 text-center">
      <p className="text-7xl font-bold tracking-tighter">404</p>
      <p className="text-muted-foreground">{t('errors.not_found')}</p>
      <Button asChild>
        <Link to="/">{t('nav.dashboard')}</Link>
      </Button>
    </div>
  );
}
